/* Pulsea — scroll reveal for [data-pulsea-reveal] elements */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const reveal = () => {
    const els = document.querySelectorAll('[data-pulsea-reveal]:not(.pulsea-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('pulsea-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('pulsea-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }

  // Theme editor: re-run when sections are re-rendered
  document.addEventListener('shopify:section:load', reveal);
})();
